import React, { useState } from "react";
import FileTag from "./FileTag";
import { AiOutlineMinus } from "react-icons/ai";
import { useEffect } from "react";
const MultiInputDataTag = ({
  id,
  label,
  length,
  name,
  defaultTitle,
  defaultParagraph,
  defaultImage,
  type,
  required,
  textAreaRequired,
  noImage,
  setRemoveHelper,
  indexNo,
  imgTitle,
  multipleData,
  noIndex,
}) => {
  const [visibility, setVisibility] = useState(true);
  const [inputValue, setInputValue] = useState("");
  const [error, setError] = useState("");
  const [serial, setSerial] = useState([]);
  //console.log(id);
  const handleDelete = (id) => {
    setRemoveHelper(id);
    //setVisibility(false);
  };
  useEffect(() => {
    let temp = [];
    if (multipleData?.length) {
      multipleData?.forEach((element) => {
        const val = parseInt(element?.defaultValue?.index);
        temp.push(val);
      });
    }
    if (temp.length) {
      setSerial(temp);
    }
  }, [multipleData]);

  const handleSerial = (e, currentVal) => {
    e.preventDefault();
    const inpVal = +e.target.value;
    if (inpVal <= 0) {
      setError("Input value must be greater than 0");
    } else if (inpVal && currentVal) {
      if (serial?.includes(inpVal)) {
        setError(
          `Without save and refresh you can't use these flowing values ${serial}`
        );
      } else {
        let index = serial.indexOf(+currentVal);
        /*  if (index > -1) {
          serial[index] = inpVal;
          setSerial(serial);
          setError("");
          setInputValue(inpVal);
        } else { }*/
        serial.splice(index, 1);
        setSerial([...serial, inpVal]);
        setError("");
        setInputValue(inpVal);
      }
    } else {
      if (serial?.includes(inpVal)) {
        setError("Input value must be unique");
      } else {
        setError("");
        setInputValue(inpVal);
        setSerial([...serial, inpVal]);
        //serial.push(inpVal);
      }
    }
  };
  return (
    <div
      id={id}
      key={Math.random()}
      className={`${
        visibility
          ? "last:mb-20 pt-5 first:pt-0 mb-8"
          : "gap-1 items-end hidden"
      } `}
    >
      <div className="flex gap-2">
        <label className="input-group flex-col gap-3">
          <span className="text-md font-semibold p-0">
            {length ? label + " " + length : label}
          </span>
          {/* {!noIndex && ( */}
          <label className="pt-0">
            <span className="text-sm font-normal p-0 mb-2">Index No</span>
            <input
              name={visibility ? name : ""}
              defaultValue={inputValue ? inputValue : indexNo}
              type="number"
              className="wew input input-bordered w-full z-0 rounded-lg"
              required={required}
              placeholder="Index No"
              onBlur={(e) => {
                handleSerial(e, indexNo);
              }}
            />
            {error && (
              <div
                className="bg-orange-100 border-l-4 border-orange-500 text-orange-700 p-4 mt-2"
                role="alert"
              >
                <p className="font-bold">Error</p>
                <p className="text-red-400">{error}</p>
              </div>
            )}
          </label>
          {/* // )} */}
          <label className="pt-0">
            <span className="text-sm font-normal p-0 mb-2">Title</span>
            <input
              name={visibility ? name : ""}
              defaultValue={defaultTitle}
              type={type}
              className="wew input input-bordered w-full z-0 rounded-lg"
              required={required}
              placeholder="Title"
            />
          </label>
          <label className="pt-0">
            <span className="text-sm font-normal p-0 mb-2">Description</span>
            <textarea
              rows={6}
              name={visibility ? name : ""}
              defaultValue={defaultParagraph}
              type="Text"
              className="wew textarea textarea-bordered rounded-lg w-full"
              required={textAreaRequired}
              placeholder="Description"
            />
          </label>

          {!noImage && (
            <>
              {/* img title  */}
              <label className="pt-0">
                <span className="text-sm font-normal p-0 mb-2">
                  Image Title
                </span>
                <input
                  name={visibility ? name : ""}
                  defaultValue={imgTitle}
                  type={type}
                  className="wew input input-bordered w-full z-0 rounded-lg"
                  required={required}
                  placeholder="Image Title"
                />
              </label>

              <label className="pt-0">
                <span className="text-sm font-normal p-0 mb-2">Image</span>
                <FileTag
                  label={label}
                  length={length}
                  name={name}
                  defaultValue={defaultImage}
                  type={type}
                />
              </label>
            </>
          )}
        </label>

        {/* empty label */}

        {/* btn add */}
        <div className="pt-16 pb-1">
          <button
            type="button"
            onClick={() => {
              handleDelete(id);
            }}
            className="btn btn-sm h-full"
          >
            <AiOutlineMinus />
          </button>
        </div>
      </div>
    </div>
  );
};

export default MultiInputDataTag;
